import useSendDataHubConsume from 'src/hook/useSendDatahubConsume/useSendDatahubConsume'
import { Actions, Entities } from 'src/utils/datahub/enums'
import { ComponentNames, EventNames, ScreenNames } from 'src/utils/datahub/enums'
import { useUser } from 'src/hook/useUser'
import { useCommunityDetails } from 'src/pages/CommunityDetails/Posts/context/communityDetailsContext'

const useTrackEvents = () => {
  const { sendDataHubConsume } = useSendDataHubConsume()
  const { community } = useCommunityDetails()
  const { user } = useUser()

  const sendMyPostsEvent = () => {
    sendDataHubConsume({
      action: Actions.VIEW,
      entity: Entities.COMMUNITY,
      event: {
        screenName: ScreenNames.HOME_COMMUNITY,
        eventName: EventNames.CLICK_TO_SELECT_COMMUNITY_FILTER_MY_POSTS,
        componentName: ComponentNames.COMMUNITY_FEED,
        communityId: Number(community.id)
      }
    })
  }

  const sendScheduledPostsEvent = () => {
    sendDataHubConsume({
      action: Actions.SETUP,
      entity: Entities.SCHEDULED_POST,
      event: {
        screenName: ScreenNames.FILTER_SCHEDULED_LIST,
        eventName: EventNames.CLICK_TO_GO_TO_SCHEDULED_POSTS,
        componentName: ComponentNames.FILTER_BUTTON,
        user: {
          id: user.id,
          name: user.name
        },
        community: {
          id: community.id,
          name: community.name
        }
      }
    })
  }

  return {
    sendMyPostsEvent,
    sendScheduledPostsEvent
  }
}

export default useTrackEvents
